import React, { Component } from 'react'
import { StyleSheet } from 'react-native'
import Modal from '@dbk/ui-modal'
import Text, { Large } from '@dbk/ui-text'
import Button from '@dbk/ui-buttons'
import { StatusError } from '@dbk/ui-icons'
import moment from 'moment'
import { ErrorIcon, SuccessIcon } from '../../components/common/icons'
import styles from './payment-confirmation.styles'
import { FormattedMessage } from '@dbk-legacy/format'
import { formatDateShortMonth, formatDateShortMonthWithoutDot } from '../../utils/date'
import { createContainer } from '@dbk-legacy/muster/react'
import { PAYMENT_MODE } from '../../muster/app/payments/constant'
import { PALETTE, ROUTES, SEPA_PAYMENT_TYPE, SEPA_IP_STATUS } from '../../constants'

class PaymentStatusModalNew extends Component {
  static defaultProps = {
    isMultisigFlow: false,
    isInitiatorFlow: false,
  }

  getTitle = () => {
    const { status, messages, isMultisigFlow, isInitiatorFlow } = this.props
    if (isMultisigFlow && isInitiatorFlow) {
      return messages['app.payments.multisig.cancelStatusModalTitleInitiator']
    } else if (isMultisigFlow && !isInitiatorFlow) {
      return messages['app.payments.multisig.cancelStatusModalTitleApprover']
    } else {
      return status === 'success'
        ? messages['app.payment.pageTitle.confirm.payment']
        : messages['app.payment.pageTitle.payment.status']
    }
  }

  onNewPayment = () => {
        this.props.payments.setCreateNewModal(true);
        this.onDone();
  }

  getPaymentList = () => {
    this.onDone();
    this.props.changePage(ROUTES.PAYMENT.DASHBOARD);
  }

  onRetry = () => {
    this.props.changePage(ROUTES.PAYMENT.NEW_DOMESTIC)
  }

  onSwitchToSepaClassic = () => {
    this.props.changePage(ROUTES.PAYMENT.NEW_DOMESTIC)
  }
  onDone = () => {
      const {payments: {isCashFlow,isCashPaymentFlow, currentTx:{signingType}} } = this.props;
      this.props.payments.resetForm();
      this.props.payments.setPosid('');
      
        if(isCashFlow) {
          if(isCashPaymentFlow){
          this.props.payments.setFlowFalse(false);
          this.props.payments.setIsCashPaymentFlow(false);  //WMCE-49821- To enable arrow due to asyncronous behaviour
          this.props.payments.setDisableTabs(false);     //WMCE-41840- For enabling Menu bar
          }
          else{
          this.props.payments.setFlowFalse(false);
          this.props.payments.setDisableTabs(false);     //WMCE-41840- For enabling Menu bar
          }
      } else {
          // if (signingType=== PAYMENT_MODE.MULTI && !this.state.isRefreshButtonClicked) {
          //   this.setState({showMultisigRejectedStatusModal: true, multisigModalStatus: MODAL_TYPE.CANCEL})
          // }
          this.props.payments.setFlowFalse(false);
          localStorage.setItem('newPaymentComplete',true);
          // this.setState({isRefreshButtonClicked: false})
        }
        this.props.changePage(ROUTES.PAYMENT.DASHBOARD);
    }

    getSepaIPPaymentStatus = () => {
      const {
        i18n: { messages },
        payments: {
          isSepaIpStatusFetching,
          sepaIpPaymentStatusData,
          sepaIpIntermediateStatusData,
        },
      } = this.props

      // While polling is in progress, don't render a terminal status screen.
      // The parent view is expected to show a spinner via isSepaIpStatusFetching.
      if (isSepaIpStatusFetching) {
        // If backend reported an intermediate 'ACCEPTED' status, surface a
        // dedicated "Payment Accepted" screen while polling continues in the
        // background waiting for a final status.
        const intermediateStatusCode = sepaIpIntermediateStatusData && sepaIpIntermediateStatusData.paymentStatusCode
        if (intermediateStatusCode === SEPA_IP_STATUS.ACCEPTED) {
          const acceptedHeader = sepaIpIntermediateStatusData && sepaIpIntermediateStatusData.paymentStatusTitle
          const acceptedDescription = sepaIpIntermediateStatusData && sepaIpIntermediateStatusData.paymentStatusReasonMessage
          return (
            <div className="payment-status-container">
              <div className="payment-status-content">
                <div className="payment-status-message">
                  <div><SuccessIcon color={PALETTE.successColor} width={48} height={48} /></div>
                  <h2
                    role="alert"
                    tabIndex={0}
                    aria-label={acceptedHeader}
                  >
                    {acceptedHeader}
                  </h2>
                </div>
                {!!acceptedDescription && (
                  <div>
                    <Large
                      role="alert"
                      tabIndex={0}
                      aria-label={acceptedDescription}
                    >
                      {acceptedDescription}
                    </Large>
                  </div>
                )}
                <div>{messages['app.payment.status.paymentProcessing']}</div>
              </div>
            </div>
          )
        }
        return <div>{messages['app.payment.status.paymentProcessing']}</div>
      }

      const statusCode = sepaIpPaymentStatusData && sepaIpPaymentStatusData.paymentStatusCode

      // Resolve icon, header and description for each final status.
      let icon = null
      let headerText = sepaIpPaymentStatusData && sepaIpPaymentStatusData.paymentStatusTitle
      let description = sepaIpPaymentStatusData && sepaIpPaymentStatusData.paymentStatusReasonMessage
      // Buttons visible in the footer for each final status.
      let showNewPaymentBtn = false
      let showRetryBtn = false
      let showPaymentListBtn = true // payment list button is always shown

      switch (statusCode) {
        case SEPA_IP_STATUS.COMPLETED:
          icon = <SuccessIcon color={PALETTE.successColor} width={48} height={48} />
          showNewPaymentBtn = true
          break
        case SEPA_IP_STATUS.REJECTED:
          icon = <StatusError color={PALETTE.errorColor} width={48} height={48} />
          showRetryBtn = true
          break
        case SEPA_IP_STATUS.TIMEOUT:
          icon = <StatusError color={PALETTE.errorColor} width={48} height={48} />
          showNewPaymentBtn = true
          break
        case SEPA_IP_STATUS.ERROR:
          icon = <ErrorIcon color={PALETTE.errorColor} width={48} height={48} />
          showNewPaymentBtn = true
          break
        default:
          headerText = messages['app.payment.status.paymentConnectionErrorHeader'];
          description = messages['app.payment.status.paymentConnectionError'];
          icon = <ErrorIcon color={PALETTE.errorColor} width={48} height={48} />
          showNewPaymentBtn = true
          break
      }

      return (
        <div className="payment-status-container">
          <div className="payment-status-content">
            <div className="payment-status-message">
              <div>{icon}</div>
              <h2
                role="alert"
                tabIndex={0}
                aria-label={headerText}
              >
                {headerText}
              </h2>
            </div>
            <div>
              <Large
                role="alert"
                tabIndex={0}
                aria-label={description}
              >
                {description}
              </Large>
            </div>
          </div>

          <div className="payment-status-footer">
            <div style={StyleSheet.flatten(styles.paymentStatusBtnTerminate)}>
              <div style={StyleSheet.flatten(styles.paymentStatusBtnBlock)}>
                {showNewPaymentBtn && (
                  <div style={StyleSheet.flatten(styles.paymentNewRMrgn)}>
                    <Button tertiary size={'large'} fullWidth onPress={this.onNewPayment}>
                      {messages['app.payments.new.payment']}
                    </Button>
                  </div>
                )}
                {showRetryBtn && (
                  <div style={StyleSheet.flatten(styles.paymentNewRMrgn)}>
                    {/* <Button tertiary size={'large'} fullWidth onPress={this.onRetry}>
                      {messages['app.common.profile.retry']}
                    </Button> */}
                    <Button tertiary size={'large'} fullWidth onPress={this.onNewPayment}>
                      {messages['app.payments.new.payment']}
                    </Button>
                  </div>
                )}
                {/* Switch to SEPA Classic button - kept for future use */}
                {/*
                {showSwitchToSepaClassicBtn && (
                  <div style={StyleSheet.flatten(styles.paymentNewRMrgn)}>
                    <Button tertiary size={'large'} fullWidth onPress={this.onSwitchToSepaClassic}>
                      {messages['app.payments.summary.sepaClassic']}
                    </Button>
                  </div>
                )}
                */}
                {showPaymentListBtn && (
                  <div>
                    <Button className="btnPaymentDone" size={'large'} fullWidth onPress={this.getPaymentList}>
                      {messages['app.payments.summary.paymentStatus.paymentList']}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )
    }
  

  render() {
    const {
      i18n: { messages },
      payments:{
        currentTx:{
          signingType,
          executionDate
        },
      isMultiSigApprovalFlow,
      paymentConfirmationStatus,
      isSepaIpStatusFetching,
      selectedBeneficiaryBankSEPAPaymentType,

      },
    } = this.props

    const isMultisigFlow =signingType === PAYMENT_MODE.MULTI
    const isInitiatorFlow=!isMultiSigApprovalFlow
    const status = paymentConfirmationStatus;
    const isExecutionDateToday = executionDate ? moment(executionDate).isSame(moment(), 'day') : false

    return (
      selectedBeneficiaryBankSEPAPaymentType === SEPA_PAYMENT_TYPE.INSTANT && isExecutionDateToday ? this.getSepaIPPaymentStatus() : (
      <div className="payment-status-container">
        {status === 'success' ? (
          <div className="payment-status-content">
            <div className="payment-status-message">
              <div>
                <SuccessIcon color={PALETTE.successColor}  width={48} height={48} />
              </div>
              <h2 size={'large'} tabIndex={0} aria-label={messages['app.payments.confirmation.success']}>
                {messages['app.payments.confirmation.success']}
              </h2>
            </div>
            <div tabIndex={0}>
              {isMultisigFlow && isInitiatorFlow ? (
                // success message for multisig initiator flow
                <>
                  <div>
                    <Large
                      role="alert"
                      tabIndex={0}
                      aria-label={messages['app.payments.multisig.successModalHeaderForInitiator1']}
                    >
                      {messages['app.payments.multisig.successModalHeaderForInitiator1']}
                    </Large>
                  </div>
                  <div>
                    <Large
                      role="alert"
                      tabIndex={0}
                      aria-label={messages['app.payments.multisig.successModalHeaderForInitiator2']}
                    >
                      {messages['app.payments.multisig.successModalHeaderForInitiator2']}
                    </Large>
                  </div>
                </>
              ) : (
                //success message for standard flow and multisig approval flow
                <FormattedMessage
                  id={'app.payments.confirmation.successMessage'}
                  values={{ executionDate: formatDateShortMonthWithoutDot(executionDate) }}
                />
              )}
            </div>
          </div>
        ) : status === 'reject' ? (
          <div className="payment-status-content">
            <div className="payment-status-message">
              <div>
                <StatusError color={PALETTE.errorColor} width={48} height={48} />
              </div>
              <h2
                role="alert"
                tabIndex={0}
                aria-label={messages['app.payments.confirmation.success']}
              >
                {messages['app.payments.confirmation.success']}
              </h2>
            </div>
            <div>
              <Large
                role="alert"
                tabIndex={0}
                aria-label={messages['app.payments.cancellation.errorMessage']}
              >
                {messages['app.payments.cancellation.errorMessage']}
              </Large>
            </div>
          </div>
        ) : status === 'failed'? (
          <div className="payment-status-content">
            <div className="payment-status-message">
              <div>
                <ErrorIcon color={PALETTE.errorColor} width={48} height={48} />
              </div>
              <h2
                role="alert"
                tabIndex={0}
                aria-label={messages['app.payment.status.paymentConnectionErrorHeader']}
              >
                {messages['app.payment.status.paymentConnectionErrorHeader']}
              </h2>
            </div>
            <div>
              <Large
                role="alert"
                tabIndex={0}
                aria-label={messages['app.payment.status.paymentConnectionError']}
              >
                {messages['app.payment.status.paymentConnectionError']}
              </Large>
            </div>
          </div>
        ) 
          : (
          <div className="payment-status-content">
            <div className="payment-status-message">
              <div>
                <ErrorIcon color={PALETTE.errorColor} width={48} height={48} />
              </div>
              <h2
                role="alert"
                tabIndex={0}
                aria-label={messages['app.payments.confirmation.dataIntegrityError']}
              >
                {messages['app.payments.confirmation.dataIntegrityError']}
              </h2>
            </div>
            <div>
              <Large
                role="alert"
                tabIndex={0}
                aria-label={messages['app.payments.dataIntegrity.errorMessage']}
              >
                {messages['app.payments.dataIntegrity.errorMessage']}
              </Large>
            </div>
          </div>
        )}

        <div className="payment-status-footer">
          <div style={StyleSheet.flatten(styles.paymentStatusBtnTerminate)}>
            {status === 'terminate' ? (
              <div>
                <Button fullWidth size={'large'} onPress={this.onDone}>
                  {messages['app.forgotPassword.button.ok']}
                </Button>
              </div>
            ) : (
              <div style={StyleSheet.flatten(styles.paymentStatusBtnBlock)}>
                <div style={StyleSheet.flatten(styles.paymentNewRMrgn)}>
                  <Button tertiary size={'large'} fullWidth onPress={this.onNewPayment}>
                    {messages['app.payments.new.payment']}
                  </Button>
                </div>
                {/* <div style={StyleSheet.flatten(styles.paymentNewRMrgn)}>
                  <Button tertiary size={'large'} fullWidth onPress={this.onRetry}>
                    {messages['app.common.profile.retry']}
                  </Button>
                </div>
                <div style={StyleSheet.flatten(styles.paymentNewRMrgn)}>
                  <Button tertiary size={'large'} fullWidth onPress={this.onSwitchToSepaClassic}>
                    {messages['app.payments.summary.sepaClassic']}
                  </Button>
                </div> */}
                <div>
                  <Button className="btnPaymentDone" size={'large'} fullWidth onPress={this.getPaymentList}>
                    {messages['app.payments.summary.paymentStatus.paymentList']}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  )
  }
}

export default createContainer({
  $queries: {
    i18n: { messages: true },
    changePage: { $call: 'ui.history.push' },
    payments: {
      initializeTx: { $call: 'initializeTx' },
      cancelTx: { $call: 'cancelTx' },
      paymentType: true,
      webTxnTimeout: true,
      paymentRefresh: { showSpinner: true },
      getRefreshStatus: { $call: 'getPaymentStatus' },

      isMultiSigApprovalFlow: true,
      currentTx: true,
      paymentConfirmationStatus: true,
      setCreateNewModal: { $set: 'createNewModal' },
      isCashFlow: true,
      isCashPaymentFlow:true,
      selectedBeneficiaryBankSEPAPaymentType: true,


      resetForm: { $call: 'resetForm'},
      setPosid: { $set: 'psPosId' },
      setCreateNewModal: { $set: 'createNewModal' },
      setFlowFalse: { $set: 'isCashFlow' },
      setIsCashPaymentFlow: { $set: 'isCashPaymentFlow' },
      setDisableTabs: { $set: 'disableTabs'},
      isSepaIpStatusFetching: true,
      sepaIpPaymentStatusData: true,
      sepaIpIntermediateStatusData: true,
    },
     portfolio: {
        setAssetClassName: { $set: 'assetClassName' }
    },
  },
})(PaymentStatusModalNew)